export default "__VITE_ASSET__Dts0SfFz__"